import Vue from 'vue';
export default Vue.extend({
    name: 'Card',
    props: {
        titleProp: { type: String, default: '' },
        subtitleProp: { type: String, default: '' },
        hideHeader: { type: Boolean, default: false },
        hideBody: { type: Boolean, default: false },
        hideFooter: { type: Boolean, default: false },
        styleProp: { type: String, default: '' },
        headerCardSectionStyles: { type: String, default: '' },
        bodyCardSectionStyles: { type: String, default: '' },
        footerCardSectionStyles: { type: String, default: '' },
        loadingProp: { type: Boolean },
        stickyFooterProp: { type: Boolean },
        showCloseButtonInUpperRightCornerProp: { type: Boolean },
        qCardProps: { type: Object, default: () => ({}) },
        bodyProp: { type: Object }
    },
    computed: {
        computedFooterStyle() {
            let res = this.footerCardSectionStyles;
            if (this.stickyFooterProp)
                res += ';position:sticky;bottom:0';
            return res;
        }
    }
});
